export default __webpack_public_path__ + "static/media/checkin.268bd1a6.svg";